import React from "react";
import { Link } from "react-router-dom";

interface AuthLayoutProps {
  children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        {/* Logo and Header */}
        <div className="text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-3"
          >
            <div className="sf-logo-mark h-11 w-11 rounded-[14px] text-2xl">S</div>
            <span className="text-[26px] font-extrabold tracking-tight text-fg-bright">
              SOLOFIX
            </span>
          </Link>
        </div>

        {/* Auth Form Container */}
        <div className="sf-card p-8">{children}</div>

      </div>
    </div>
  );
};

export default AuthLayout;
